import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as S from './empty-cart.styles';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';

export const EmptyCart = () => {
    return (
        <S.EmptyState>
            <FontAwesomeIcon icon={faShoppingCart} className="icon" />
            <p className="title">Seu carrinho está vazio.</p>
            <p className="subtitle">
                Assim que você escolher um produto, ele aparecerá aqui!
            </p>
        </S.EmptyState>
    )
}